import { gql } from '@grandvisionhq/graphql';

const storeById = gql`
  fragment Reschedule_StoreById on Store {
    globalStoreId
    town
    additionalStreetInfo
    streetNumber
    streetName
    name
    postalCode
    code
    slug
    province
    country
    lat
    lon
    phone
    email
  }
`;
const GET_STORE_BY_ID = gql`
  query RescheduleAppointment_GetStoreById($globalStoreId: ID!) {
    store(globalStoreId: $globalStoreId) {
      ...Reschedule_StoreById
    }
  }
  ${storeById}
`;

export { GET_STORE_BY_ID };
//# sourceMappingURL=get-store-by-id.js.map
